// extracted by mini-css-extract-plugin
module.exports = {"socialLinks":"social-links-module--socialLinks--2nbuk","socialLink":"social-links-module--socialLink--1M1lI"};